import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const RIGHT = () => {
  return (
    <CardSection id="RIGHT" title="RIGHT">
      <Paragraph>
        텍스트 문자열의 가장 오른쪽(끝) 위치부터 시작하여 지정된 수의 문자를
        반환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>RIGHT(STRING, VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>STRING</b>은 검색하려는 문자열입니다.
          </Li>
          <Li>
            <b>VALUE</b>는 반환할 문자 수입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>RIGHT(`product`, 4)</Paragraph>
        <Img src="computeRight" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>STRING</b>은 텍스트 문자열, 텍스트 문자열을 포함하는 열
          또는 텍스트 문자열을 반환하는 함수여야 합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
